function init() {
  if (document.querySelector('.p-applyBtn')) {
    updateApplyLinks();
    bindApplyConversion();
  }
}

// 申込リンクに現在のURLパラメータを引き継ぐ
function updateApplyLinks() {
  const queryString = window.location.search; // 現在のURLのパラメータ
  const applyLinks = document.querySelectorAll('.p-applyBtn a');

  applyLinks.forEach(link => {
    if (queryString) {
      const separator = link.href.includes('?') ? '&' : '?';
      link.href += separator + queryString.substring(1); // "?" を除いて結合
    }
  });
}

/** 来訪元媒体を ?001/002/003 で判定（キーなしパラメータ想定） */
function detectMedium() {
  const q = window.location.search || '';
  // 例: ?001, &001, ?001&foo=bar などを検出
  if (/(?:^\?|&)company_cd=000010(?:&|$)/.test(q)) return "google";
  if (/(?:^\?|&)company_cd=000011(?:&|$)/.test(q)) return "x";
  if (/(?:^\?|&)company_cd=000012(?:&|$)/.test(q)) return "tiktok";
  return null; // 該当なし
}

/** 媒体ごとの発火関数 */
function fireGoogleConversion(url) {
  if (typeof gtag !== 'function') return;
  //console.warn('[Google] Conversion fired');
  gtag('event', 'conversion', {
    send_to: 'AW-17423045371/ZPkDCPT9jokbEPul-vNA',
    event_callback: function () {
      // 念のため callback 内でも新タブを開く
      try { window.open(url, '_blank'); } catch(e){}
    }
  });
}

function fireXConversion() {
  //console.warn('[X] Conversion fired');
  if (typeof twq !== 'function') return;
  twq('event', 'tw-qcuby-qcud3', {});
}

function fireTikTokConversion() {
  //console.warn('[TikTok] Conversion fired');
  if (typeof ttq === 'undefined' || !ttq.instance) return;
  ttq.instance('D2K2V93C77U067DPRPC0').track('ClickButton');
}

/**
 * 各申込ボタンにクリックイベントを付与して、
 * URLパラメータ (?001/?002/?003) に応じて発火先を分岐
 */
function bindApplyConversion() {
  const applyBtns = document.querySelectorAll('.p-applyBtn a');
  const medium = detectMedium(); // 'google' | 'x' | 'tiktok' | null

  applyBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      // --- 分岐発火 ---
      if (medium === 'google') {
        fireGoogleConversion(btn.href);
      } else if (medium === 'x') {
        fireXConversion();
      } else if (medium === 'tiktok') {
        fireTikTokConversion();
      } else {
        // パラメータがない/一致しない場合は発火なし
        // ※ 全媒体発火したい場合は下行を有効化:
        // fireGoogleConversion(btn.href); fireXConversion(); fireTikTokConversion();
      }

      // 保険：callbackが動かなくても必ず新タブで開く
      setTimeout(() => {
        try { window.open(btn.href, '_blank'); } catch(e){}
      }, 300);
    });
  });
}

export default { init };
